import React, { useState, useEffect } from 'react';
import KnotDecoration from './illustrations/KnotDecoration';

const FORMSUBMIT_URL = 'https://formsubmit.co/ajax/inerva.psicologia@gmail.com';

export default function ContactModal({ show, handleClose }) {
  const [formData, setFormData] = useState({
    nombreCompleto: '',
    correo: '',
    telefono: '',
    mensaje: '',
  });
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [show]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch(FORMSUBMIT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          nombre: formData.nombreCompleto,
          email: formData.correo,
          telefono: formData.telefono,
          mensaje: formData.mensaje,
          _replyto: formData.correo,
          _subject: `Nuevo mensaje de ${formData.nombreCompleto} - Inerva Psicología`,
          _template: 'table',
          _captcha: 'false',
          _honeypot: '',
        }),
      });
      const data = await res.json();
      if (data.success) {
        setSent(true);
        setFormData({ nombreCompleto: '', correo: '', telefono: '', mensaje: '' });
      } else {
        throw new Error('FormSubmit error');
      }
    } catch (error) {
      console.error('Error al enviar el mensaje:', error);
      alert('Hubo un problema al enviar el mensaje. Inténtalo de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    setSent(false);
    handleClose();
  };

  if (!show) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      onClick={handleCloseModal}
    >
      <div className="absolute inset-0 bg-[var(--color-inerva-forest)]/60 backdrop-blur-sm animate-fadeIn" />

      <div
        className="relative w-full max-w-md bg-white rounded-2xl shadow-2xl animate-slideUp"
        onClick={(e) => e.stopPropagation()}
      >
        {!sent ? (
          <>
            <div className="p-6 pb-0">
              <div className="flex items-start justify-between">
                <div>
                  <h3 className="text-xl font-serif text-[var(--color-inerva-forest)] mb-1">
                    Contacta conmigo
                  </h3>
                  <p className="text-sm text-[var(--color-inerva-text-light)]">
                    Te responderé lo antes posible
                  </p>
                </div>
                <button
                  onClick={handleCloseModal}
                  className="p-2 -mr-2 -mt-2 text-[var(--color-inerva-text-light)] hover:text-[var(--color-inerva-forest)] transition-colors"
                  aria-label="Cerrar"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </div>

            <form onSubmit={handleSubmit} className="p-6">
              <input type="text" name="_honeypot" style={{ display: 'none' }} tabIndex={-1} autoComplete="off" />
              <div className="space-y-4">
                <div>
                  <label
                    htmlFor="nombreCompleto"
                    className="block text-sm font-medium text-[var(--color-inerva-forest)] mb-2"
                  >
                    Nombre completo
                  </label>
                  <input
                    type="text"
                    id="nombreCompleto"
                    name="nombreCompleto"
                    value={formData.nombreCompleto}
                    onChange={handleChange}
                    placeholder="Tu nombre"
                    required
                    className="input-field"
                  />
                </div>

                <div>
                  <label
                    htmlFor="correo"
                    className="block text-sm font-medium text-[var(--color-inerva-forest)] mb-2"
                  >
                    Correo electrónico
                  </label>
                  <input
                    type="email"
                    id="correo"
                    name="correo"
                    value={formData.correo}
                    onChange={handleChange}
                    placeholder="ejemplo@correo.com"
                    required
                    className="input-field"
                  />
                </div>

                <div>
                  <label
                    htmlFor="telefono"
                    className="block text-sm font-medium text-[var(--color-inerva-forest)] mb-2"
                  >
                    Teléfono
                  </label>
                  <input
                    type="tel"
                    id="telefono"
                    name="telefono"
                    value={formData.telefono}
                    onChange={handleChange}
                    placeholder="612 345 678"
                    className="input-field"
                  />
                </div>

                <div>
                  <label
                    htmlFor="mensaje"
                    className="block text-sm font-medium text-[var(--color-inerva-forest)] mb-2"
                  >
                    Mensaje
                  </label>
                  <textarea
                    id="mensaje"
                    name="mensaje"
                    value={formData.mensaje}
                    onChange={handleChange}
                    rows={4}
                    placeholder="Cuéntame en qué puedo ayudarte..."
                    required
                    className="input-field resize-none"
                  />
                </div>
              </div>

              <div className="flex gap-3 mt-6">
                <button
                  type="button"
                  onClick={handleCloseModal}
                  className="flex-1 btn-secondary py-3"
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className="flex-1 btn-primary py-3 disabled:opacity-60"
                >
                  {loading ? (
                    <span className="flex items-center justify-center gap-2">
                      <svg className="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                      </svg>
                      Enviando...
                    </span>
                  ) : (
                    'Enviar mensaje'
                  )}
                </button>
              </div>
            </form>
          </>
        ) : (
          <div className="p-8 text-center">
            <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-mint flex items-center justify-center">
              <svg className="w-8 h-8 text-[var(--color-inerva-forest)]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>

            <h3 className="text-xl font-serif text-[var(--color-inerva-forest)] mb-2">
              ¡Mensaje enviado!
            </h3>
            <p className="text-[var(--color-inerva-text-light)] mb-6">
              Gracias por contactarme. Te responderé lo antes posible.
            </p>

            <KnotDecoration size="sm" className="mx-auto mb-6 opacity-30" />

            <button onClick={handleCloseModal} className="btn-primary">
              Cerrar
            </button>
          </div>
        )}
      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(20px) scale(0.95); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }
        .animate-fadeIn { animation: fadeIn 0.2s ease-out; }
        .animate-slideUp { animation: slideUp 0.3s ease-out; }
      `}</style>
    </div>
  );
}
